// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Icons from "@sothebys/sterling/icons";

var make = Icons.Collection48.ChevronLeft48;

var ChevronLeft48 = {
  make: make
};

var make$1 = Icons.Collection24.Paddle24;

var Paddle24 = {
  make: make$1
};

var make$2 = Icons.Collection24.Minus24;

var Minus24 = {
  make: make$2
};

var make$3 = Icons.Collection24.Plus24;

var Plus24 = {
  make: make$3
};

var make$4 = Icons.Collection24.Mobile24;

var Mobile24 = {
  make: make$4
};

var make$5 = Icons.Collection24.Email24;

var Email24 = {
  make: make$5
};

var make$6 = Icons.Collection24.CloseRegular24;

var CloseRegular24 = {
  make: make$6
};

var make$7 = Icons.Collection24.ArrowLeft24;

var ArrowLeft24 = {
  make: make$7
};

var make$8 = Icons.Collection24.ArrowRight24;

var ArrowRight24 = {
  make: make$8
};

var make$9 = Icons.Collection24.ArrowShow24;

var ArrowShow24 = {
  make: make$9
};

var make$10 = Icons.Collection24.ArrowHide24;

var ArrowHide24 = {
  make: make$10
};

var make$11 = Icons.Collection24.FullView24;

var FullView24 = {
  make: make$11
};

var make$12 = Icons.Collection24.User24;

var User24 = {
  make: make$12
};

var make$13 = Icons.Collection24.Attention24;

var Attention24 = {
  make: make$13
};

var make$14 = Icons.Collection48.Attention48;

var Attention48 = {
  make: make$14
};

var make$15 = Icons.Collection24.MediaSoundOff24;

var MediaSoundOff24 = {
  make: make$15
};

var make$16 = Icons.Collection24.MediaSoundOn24;

var MediaSoundOn24 = {
  make: make$16
};

var make$17 = Icons.Collection24.MediaPlayCircle24;

var MediaPlayCircle24 = {
  make: make$17
};

var make$18 = Icons.Collection24.TextListNumbered24;

var TextListNumbered24 = {
  make: make$18
};

var make$19 = Icons.Collection24.Browser24;

var Browser24 = {
  make: make$19
};

var make$20 = Icons.Collection24.Gavel24;

var Gavel24 = {
  make: make$20
};

var make$21 = Icons.Collection24.Telephone24;

var Telephone24 = {
  make: make$21
};

var make$22 = Icons.Collection48.ChevronUp48;

var ChevronUp48 = {
  make: make$22
};

var make$23 = Icons.Collection24.MediaLiveVideoOff24;

var MediaLiveVideoOff24 = {
  make: make$23
};

var make$24 = Icons.Collection24Filled.Exclamation24Filled;

var Exclamation24Filled = {
  make: make$24
};

var make$25 = Icons.Collection48.Exhibition48;

var Exhibition48 = {
  make: make$25
};

var Collection = {
  ChevronLeft48: ChevronLeft48,
  Paddle24: Paddle24,
  Minus24: Minus24,
  Plus24: Plus24,
  Mobile24: Mobile24,
  Email24: Email24,
  CloseRegular24: CloseRegular24,
  ArrowLeft24: ArrowLeft24,
  ArrowRight24: ArrowRight24,
  ArrowShow24: ArrowShow24,
  ArrowHide24: ArrowHide24,
  FullView24: FullView24,
  User24: User24,
  Attention24: Attention24,
  Attention48: Attention48,
  MediaSoundOff24: MediaSoundOff24,
  MediaSoundOn24: MediaSoundOn24,
  MediaPlayCircle24: MediaPlayCircle24,
  TextListNumbered24: TextListNumbered24,
  Browser24: Browser24,
  Gavel24: Gavel24,
  Telephone24: Telephone24,
  ChevronUp48: ChevronUp48,
  MediaLiveVideoOff24: MediaLiveVideoOff24,
  Exclamation24Filled: Exclamation24Filled,
  Exhibition48: Exhibition48
};

var make$26 = Icons.Flags48Rounded.Eu48Rounded;

var Eu48Rounded = {
  make: make$26
};

var make$27 = Icons.Flags48Rounded.Ae48Rounded;

var Ae48Rounded = {
  make: make$27
};

var make$28 = Icons.Flags48Rounded.Ar48Rounded;

var Ar48Rounded = {
  make: make$28
};

var make$29 = Icons.Flags48Rounded.Au48Rounded;

var Au48Rounded = {
  make: make$29
};

var make$30 = Icons.Flags48Rounded.Br48Rounded;

var Br48Rounded = {
  make: make$30
};

var make$31 = Icons.Flags48Rounded.Ca48Rounded;

var Ca48Rounded = {
  make: make$31
};

var make$32 = Icons.Flags48Rounded.Ch48Rounded;

var Ch48Rounded = {
  make: make$32
};

var make$33 = Icons.Flags48Rounded.Cn48Rounded;

var Cn48Rounded = {
  make: make$33
};

var make$34 = Icons.Flags48Rounded.Gb48Rounded;

var Gb48Rounded = {
  make: make$34
};

var make$35 = Icons.Flags48Rounded.Hk48Rounded;

var Hk48Rounded = {
  make: make$35
};

var make$36 = Icons.Flags48Rounded.Id48Rounded;

var Id48Rounded = {
  make: make$36
};

var make$37 = Icons.Flags48Rounded.In48Rounded;

var In48Rounded = {
  make: make$37
};

var make$38 = Icons.Flags48Rounded.Jp48Rounded;

var Jp48Rounded = {
  make: make$38
};

var make$39 = Icons.Flags48Rounded.Kr48Rounded;

var Kr48Rounded = {
  make: make$39
};

var make$40 = Icons.Flags48Rounded.Mx48Rounded;

var Mx48Rounded = {
  make: make$40
};

var make$41 = Icons.Flags48Rounded.Ph48Rounded;

var Ph48Rounded = {
  make: make$41
};

var make$42 = Icons.Flags48Rounded.Qa48Rounded;

var Qa48Rounded = {
  make: make$42
};

var make$43 = Icons.Flags48Rounded.Ru48Rounded;

var Ru48Rounded = {
  make: make$43
};

var make$44 = Icons.Flags48Rounded.Sa48Rounded;

var Sa48Rounded = {
  make: make$44
};

var make$45 = Icons.Flags48Rounded.Sg48Rounded;

var Sg48Rounded = {
  make: make$45
};

var make$46 = Icons.Flags48Rounded.Tw48Rounded;

var Tw48Rounded = {
  make: make$46
};

var make$47 = Icons.Flags48Rounded.Us48Rounded;

var Us48Rounded = {
  make: make$47
};

var make$48 = Icons.Flags48Rounded.Eth48Rounded;

var Eth48Rounded = {
  make: make$48
};

var make$49 = Icons.Flags48Rounded.Btc48Rounded;

var Btc48Rounded = {
  make: make$49
};

var Flags = {
  Eu48Rounded: Eu48Rounded,
  Ae48Rounded: Ae48Rounded,
  Ar48Rounded: Ar48Rounded,
  Au48Rounded: Au48Rounded,
  Br48Rounded: Br48Rounded,
  Ca48Rounded: Ca48Rounded,
  Ch48Rounded: Ch48Rounded,
  Cn48Rounded: Cn48Rounded,
  Gb48Rounded: Gb48Rounded,
  Hk48Rounded: Hk48Rounded,
  Id48Rounded: Id48Rounded,
  In48Rounded: In48Rounded,
  Jp48Rounded: Jp48Rounded,
  Kr48Rounded: Kr48Rounded,
  Mx48Rounded: Mx48Rounded,
  Ph48Rounded: Ph48Rounded,
  Qa48Rounded: Qa48Rounded,
  Ru48Rounded: Ru48Rounded,
  Sa48Rounded: Sa48Rounded,
  Sg48Rounded: Sg48Rounded,
  Tw48Rounded: Tw48Rounded,
  Us48Rounded: Us48Rounded,
  Eth48Rounded: Eth48Rounded,
  Btc48Rounded: Btc48Rounded
};

export {
  Collection ,
  Flags ,
}
/* make Not a pure module */
